import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import StyledComponent from "./Styled";
import { Typography, Grid } from "../..";
/**
 * moaui Styled TextField
 *
 * @param {StyledProps} props - defaultValue, title, titlePosition, error, disabled, placeholder, onChange, value, width, height, multiline, rows, maxRows, numberOptions
 * @example
 * <TextFieldV2
 * 	id=""
 * 	autoFocus={false || true}
 * 	type={'text' || 'number' || 'password'}
 * 	placeholder={'Placeholder'}
 * 	title={'Title'}
 * 	titlePosition={'left' || 'right' || 'top' || 'bottom'}
 * 	defaultValue={'Default Value'}
 * 	error={false || true}
 * 	disabled={false || true}
 * 	onChange={(event) => {}}
 * 	value={''}
 * 	width={'150px'}
 * 	height={'30px'}
 * 	textAlign={'left' || 'center' || 'right'}
 * 	multiline={false || true}
 * 	rows={1}
 * 	maxRows={1}
 * 	numberOptions={{
 * 		min: 0,
 * 		max: 100,
 * 		step: 1,
 * 		onlyInteger: {true || false},
 * 		condition: {{
 * 				min: 0,
 * 				max: 100,
 * 		}}
 * 	}}
 *
 * @returns {React.ReactElement} moaTextField
 */
var TextFieldV2 = function (props) {
    var title = props.title, titlePosition = props.titlePosition, singleLineTitle = props.singleLineTitle, width = props.width, gap = props.gap, titleXs = props.titleXs, inputXs = props.inputXs, rest = __rest(props, ["title", "titlePosition", "singleLineTitle", "width", "gap", "titleXs", "inputXs"]);
    var flexResolver = React.useCallback(function (titlePosition) {
        switch (titlePosition) {
            case "left": return "row";
            case "right": return "row-reverse";
            case "top": return "column";
            case "bottom": return "column-reverse";
            default: return "row";
        }
    }, []);
    return (_jsxs(React.Fragment, { children: [title &&
                _jsx(Grid, { width: "".concat(width), flexDirection: flexResolver(titlePosition), flexWrap: "nowrap", container: true, gap: gap, children: _jsxs(React.Fragment, { children: [_jsx(Grid, { item: true, xs: ["bottom", "top"].includes(titlePosition || "") ? 12 : titleXs || 6, display: "flex", alignItems: "center", justifyContent: titlePosition === "right" ? "end" : "start", children: _jsx(Typography, { singleLine: singleLineTitle, children: "".concat(title) }) }), _jsx(Grid, { item: true, xs: ["bottom", "top"].includes(titlePosition || "") ? 12 : inputXs || 6, children: _jsx(StyledComponent, __assign({}, rest)) })] }) }), !title &&
                _jsx(Grid, { width: width, children: _jsx(StyledComponent, __assign({}, rest)) })] }));
};
TextFieldV2.defaultProps = {
    autoFocus: false,
    type: "text",
    title: "",
    titlePosition: "left",
    error: false,
    disabled: false,
    gap: 1,
    inputAlign: "left",
    singleLineTitle: false,
};
var SampleProps = {
    id: "",
    autoFocus: false,
    type: "text",
    placeholder: "Placeholder",
    title: "Title",
    titlePosition: "left",
    error: false,
    disabled: false,
    onChange: function () { },
    width: '150px',
    titleXs: 3,
    inputXs: 9,
    height: '30px',
    textAlign: "left",
    multiline: false,
    rows: 1,
    maxRows: 1,
    gap: 1,
    inputAlign: "left",
    singleLineTitle: false,
};
export default TextFieldV2;
export { SampleProps as TextFieldV2Sample, };
